import ApiService from '../api.service';

const refsService = {
    getServOrgList: async function(itemsPerPage, currentItem) {
        try {
            let response = await ApiService.get('refs/servorgs', {
                params: {
                    itemsPerPage,
                    currentItem
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getRoleList: async function(itemsPerPage, currentItem) {
        try {
            let response = await ApiService.get('refs/roles', {
                params: {
                    itemsPerPage,
                    currentItem
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getServOrgById: async () => {
        try {
            let response = await ApiService.get('refs/servorgById');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getUserHeaderById: async () => {
        try {
            let response = await ApiService.get('refs/UserHeaderById');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getMeterTypes: async () => {
        try {
            let response = await ApiService.get('refs/meterTypes');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getContractList: async () => {
        try {
            let response = await ApiService.get('refs/contracts');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getKSKList: async () => {
        try {
            let response = await ApiService.get('refs/ksk');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getCategoryList: async function(itemsPerPage, currentItem) {
        try {
            let response = await ApiService.get('refs/categories', {
                params: {
                    itemsPerPage,
                    currentItem
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getRolesCategoryList: async function(itemsPerPage, currentItem) {
        try {
            let response = await ApiService.get('refs/rolescategories', {
                params: {
                    itemsPerPage,
                    currentItem
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getEngList: async function(itemsPerPage, currentItem) {
        try {
            let response = await ApiService.get('refs/Engineers');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getKSK: async req => {
        try {
            let response = await ApiService.get('refs/ksk', {
                params: {
                    ksk_rid: req.ksk_rid,
                    searchLine: req.searchLine,
                    itemsPerPage: req.itemsPerPage,
                    currentItem: req.currentItem
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getContract: async req => {
        try {
            let response = await ApiService.get('refs/contracts', {
                params: {
                    contract_rid: req.contract_rid,
                    searchLine: req.searchLine,
                    itemsPerPage: req.itemsPerPage,
                    currentItem: req.currentItem
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getDistricts: async () => {
        try {
            const response = await ApiService.get('refs/getDistricts');
            return response.data;
        } catch (e) {
            //console.log(e);
        }
    },
    fetchCenterBosses: async payload => {
        try {
            const { itemsPerPage, currentItem } = payload;
            const response = await ApiService.get('refs/getCenterBosses', { params: { itemsPerPage, currentItem } });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    addCenterBoss: async payload => {
        try {
            const response = await ApiService.post('refs/postCenterBoss', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getCustomerServiceList: async () => {
        try {
            const response = await ApiService.get('refs/getCustomerServiceCenter');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    deleteCenterBoss: async payload => {
        try {
            const response = await ApiService.delete(`refs/deleteCenterBoss?record_id=${payload}`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getInspectors: async () => {
        try {
            const response = await ApiService.get('refs/getInspectors');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getInjuctions: async () => {
        try {
            const response = await ApiService.get('refs/getInjuctions');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getReasons: async () => {
        try {
            const response = await ApiService.get('refs/getReasonConnDisconn');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getActionsTypes: async () => {
        try {
            const response = await ApiService.get('refs/getActsOfConnDisconnActionsTypes');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getShutdownTypes: async () => {
        try {
            const response = await ApiService.get('refs/getShutdownCompleted');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getRefHeatingSystem: async () => {
        try {
            const response = await ApiService.get('refs/getRefHeatingSystem');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getJobPositionTypes: async () => {
        try {
            const response = await ApiService.get('refs/getRefJobPositionsTypes');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export { refsService };
